import { Alert, Box, Card, Checkbox, Href, Text } from '@factorialco/deprecated-design-system'

import { useNavigation } from 'modules/core/hooks/useNavigation'
import i18n from 'modules/core/lib/i18n'

import integrationCodes from 'modules/marketplace/lib/integrationCodes'
import type LeaveForm from 'modules/timeoff/lib/LeaveForm'

interface Props {
  form: LeaveForm
  canCreateEauRequestOauthToken: boolean
}

const NewEauRequest = ({ form, canCreateEauRequestOauthToken }: Props) => {
  const { navigation } = useNavigation()
  const datevLaudsIntegrationDatoId = integrationCodes.datev_lauds

  return (
    <Card>
      <Card.Title size="small">{i18n.t('time_off.eau_confirmation.form.title')}</Card.Title>
      <Card.Content>
        <Box gap="s8">
          {!canCreateEauRequestOauthToken && (
            <Alert color="info">
              {i18n.tView('time_off.eau_confirmation.form.admin_token_warning', {
                link: (
                  <Href
                    href={navigation.discover.marketplace.item.settings.fullPath({
                      id: datevLaudsIntegrationDatoId,
                    })}
                    target="_blank"
                  >
                    <span style={{ textDecoration: 'underline' }}>
                      {i18n.t('time_off.eau_confirmation.form.admin_token_warning_link')}
                    </span>
                  </Href>
                ),
              })}
            </Alert>
          )}
          <Text.Normal color="grey800">
            {i18n.t('time_off.eau_confirmation.form.description')}
          </Text.Normal>

          <Box paddingTop="s12">
            <Checkbox
              checked={form.get('skip_eau_check').value}
              onChange={(event) => form.get('skip_eau_check').set(event.target.checked)}
              size="small"
              label={i18n.t('time_off.eau_confirmation.form.skip_eau_check')}
            />
          </Box>
        </Box>
      </Card.Content>
    </Card>
  )
}

export default NewEauRequest
